import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { createStore, applyMiddleware, compose, combineReducers } from 'redux';
import thunk from 'redux-thunk';

import AppFrameLayout from '../global/app_frame/app_frame_layout';
import DashboardLayout from './dashboard_layout';
import appFrameReducer from '../global/app_frame/app_frame_reducer';

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const rootReducer = combineReducers({
    app_frame: appFrameReducer
});

const store = createStore(rootReducer, composeEnhancers(
    applyMiddleware(thunk)
));

const DashboardApp = (props) => (
    <Provider store={store}>
        <BrowserRouter>
            <AppFrameLayout {...props}>
                <DashboardLayout />
            </AppFrameLayout>
        </BrowserRouter>
    </Provider>
);

export default DashboardApp;
